module.exports = __webpack_public_path__ + "static/img/smartCitiesTechColor.45e21886.png";